<template>
  <div class="req-id">
    <DpplDarkTooltip
      tooltip-placement="left"
      :tooltip-offset="12"
      light-mode
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <p
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ atsReqId }}
        </p>
      </template>
      <template #tooltip-content>
        <p class="content">
          {{ atsReqId }}
        </p>
      </template>
    </DpplDarkTooltip>
  </div>
</template>

<script setup>
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';

defineProps({
  atsReqId: {
    type: String,
    default: '',
  },
});
</script>

<style lang="less" scoped>
.req-id {
  max-width: 100%;

  :deep(p) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
    font-weight: 500;

    &.content {
      line-height: 150%;
      color: @text-light;
      overflow: visible;
      white-space: normal;
    }
  }
}
</style>
